import { render, staticRenderFns } from "./ContractStatsCard.vue?vue&type=template&id=22a26c55&"
import script from "./ContractStatsCard.vue?vue&type=script&lang=js&"
export * from "./ContractStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports